import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Settings = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const settingsModules = [
    {
      title: t('businessProfile'),
      description: 'Manage your business profile, address, and contact details',
      path: '/gposp/settings/business',
      icon: 'B',
      color: 'violet'
    },
    {
      title: t('taxGroupSettings'),
      description: 'Configure GST rates and tax categories',
      path: '/gposp/settings/tax',
      icon: 'T',
      color: 'green'
    },
    {
      title: t('categorySettings'),
      description: 'Manage product categories',
      path: '/gposp/settings/categories',
      icon: 'C',
      color: 'blue'
    },
    {
      title: 'Brands',
      description: 'Manage product brands',
      path: '/gposp/settings/brands',
      icon: 'B',
      color: 'orange'
    },
    {
      title: t('supplierSettings'),
      description: 'Manage your suppliers and vendors',
      path: '/gposp/settings/suppliers',
      icon: 'S',
      color: 'teal'
    },
    {
      title: t('customerSettings'),
      description: 'Manage customer information',
      path: '/gposp/settings/customers',
      icon: 'C',
      color: 'pink'
    },
    {
      title: t('cashierSettings'),
      description: 'Manage cashier accounts and permissions',
      path: '/gposp/settings/cashiers',
      icon: 'C',
      color: 'purple'
    },
    {
      title: t('billSettings'),
      description: 'Configure bill format and printing options',
      path: '/gposp/settings/bill',
      icon: 'B',
      color: 'slate'
    },
    {
      title: t('unitSettings'),
      description: 'Manage units of measurement and loose sales',
      path: '/gposp/settings/units',
      icon: 'U',
      color: 'cyan'
    },
    {
      title: t('expenseCategories'),
      description: 'Manage expense categories for tracking',
      path: '/gposp/settings/expense-categories',
      icon: 'E',
      color: 'amber'
    },
    {
      title: t('languageSettings'),
      description: 'Change app language / மொழி / भाषा',
      path: '/gposp/settings/language',
      icon: 'L',
      color: 'indigo'
    },
    {
      title: 'Subscription',
      description: 'View plan details, upgrade or renew',
      path: '/gposp/settings/subscription',
      icon: '₹',
      color: 'emerald',
      highlight: true
    }
  ];

  const colorClasses = {
    violet: 'bg-violet-50 text-violet-600 group-hover:bg-violet-100',
    green: 'bg-green-50 text-green-600 group-hover:bg-green-100',
    blue: 'bg-blue-50 text-blue-600 group-hover:bg-blue-100',
    orange: 'bg-orange-50 text-orange-600 group-hover:bg-orange-100',
    teal: 'bg-teal-50 text-teal-600 group-hover:bg-teal-100',
    pink: 'bg-pink-50 text-pink-600 group-hover:bg-pink-100',
    purple: 'bg-purple-50 text-purple-600 group-hover:bg-purple-100',
    slate: 'bg-slate-100 text-slate-700 group-hover:bg-slate-200',
    cyan: 'bg-cyan-50 text-cyan-600 group-hover:bg-cyan-100',
    amber: 'bg-amber-50 text-amber-600 group-hover:bg-amber-100',
    indigo: 'bg-indigo-50 text-indigo-600 group-hover:bg-indigo-100',
    emerald: 'bg-emerald-50 text-emerald-600 group-hover:bg-emerald-100'
  };

  return (
    <div data-testid="settings-page">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">{t('settings')}</h1>
        <p className="text-slate-500 mt-1">Manage your store configuration and master data</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {settingsModules.map((module, index) => (
          <div
            key={index}
            onClick={() => navigate(module.path)}
            className="bg-white rounded-xl border border-slate-200 p-5 hover:shadow-lg hover:border-violet-300 transition-all cursor-pointer group"
            data-testid={`settings-card-${module.title.toLowerCase().replace(/[^a-z]/g, '-')}`}
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center transition-colors ${colorClasses[module.color]}`}>
                <span className="text-xl font-bold">{module.icon}</span>
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-slate-800 group-hover:text-violet-600 transition-colors">
                  {module.title}
                </h3>
                <p className="text-sm text-slate-500 mt-1">{module.description}</p>
              </div>
            </div>
            <div className="mt-4 flex justify-end">
              <span className="text-violet-600 text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity flex items-center gap-1">
                Manage
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Settings;
